import { render, staticRenderFns } from "./small-report-form.vue?vue&type=template&id=717f6346&scoped=true&"
import script from "./small-report-form.vue?vue&type=script&lang=js&"
export * from "./small-report-form.vue?vue&type=script&lang=js&"
import style0 from "./small-report-form.vue?vue&type=style&index=0&id=717f6346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f6346",
  null
  
)

export default component.exports